import React from 'react';
import PropTypes from 'prop-types';
import config from 'config/env';
import { useSelector } from 'react-redux';
import ProfileCircularMenu from 'components/@2025/ProfileCircularMenu';

/**
 * The account row at the foot of the sidebar: the profile menu. Dark mode is
 * design tooling and stays behind the dev-only gate `ThemeModeToggler`
 * applies on the public layouts. The typeface picker and the walkthrough
 * launcher that used to sit beside it are in the topbar's top-right corner
 * (`TopbarUtilities`).
 *
 * `collapsed` stacks it into a single icon column -- the collapsed one-level
 * sidebar, and the two-level sidebar's rail.
 */
const SidebarAccountRow = ({ collapsed }) => {
  const userDetails = useSelector((state) => state.userDetails.userDetails);
  const userInfo = JSON.parse(localStorage.getItem('userInfo') || 'null');
  const showDevThemeControls = config.isLocal || config.isDevelopment;

  return (
    <ProfileCircularMenu
      userInfo={userInfo}
      userDetails={userDetails}
      variant="sidebar"
      collapsed={collapsed}
      width={32}
      height={32}
      dataTour="sidebar-profile"
      showThemeToggle={showDevThemeControls}
    />
  );
};

SidebarAccountRow.propTypes = {
  collapsed: PropTypes.bool,
};

export default SidebarAccountRow;
